import { render } from "./MWSocialLink.vue?vue&type=template&id=b7c119a6"
import script from "./MWSocialLink.vue?vue&type=script&lang=js"
export * from "./MWSocialLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__